import type { JSX } from 'react';

import { cn } from '../../../v2';
import { IconArrowDropDown } from '../../icons';

export function TitleChevron({
  testId,
  rotated,
  className,
}: {
  testId?: string;
  rotated?: boolean;
  className?: string;
}): JSX.Element {
  return (
    <div
      className={cn(
        'hover:bg-steel-100 dark:hover:bg-brand-400 ml-1 inline-block transform rounded-full bg-none transition duration-300 ease-in-out',
        {
          'expanded rotate-180': rotated,
        },
        className,
      )}
    >
      <IconArrowDropDown size={20} testId={`${testId}-expand-btn`} />
    </div>
  );
}
